import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Dialog, FadeOverflow } from '@root/shared/ui-kit'

import { PoolCard } from '../common/pool-card'

import type { PairModel } from '@root/entities/pair'
import type { DialogControlProps } from '@root/shared/ui-kit'

type SwapPairsDialogProps = {
  pairs: Array<PairModel>
  onSelectPool: (pool: PairModel) => void
} & DialogControlProps

export const SwapPairsDialog: React.FC<SwapPairsDialogProps> = ({
  open,
  onOpenChange,
  onSelectPool,
  pairs,
}) => {
  const { t } = useTranslation()

  return (
    <Root
      open={open}
      onOpenChange={onOpenChange}
      describedBy={t('pool.select-pool')}
    >
      <Dialog.Header>{t('pool.select-pool')}</Dialog.Header>
      <List mode="always" variant="vertical">
        {pairs.map((pair) => (
          <PoolCard
            key={pair.address}
            pool={pair}
            onClick={() => onSelectPool(pair)}
          />
        ))}
      </List>
    </Root>
  )
}

const Root = styled(Dialog)`
  width: 360px;
  max-height: 65vh;
`

const List = styled(FadeOverflow)`
  display: grid;
  align-content: start;
  grid-gap: 10px;
  overflow-y: auto;
  padding-inline: 10px;
  padding-block: 12px;
`
